function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavaScriptframeworksRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.75,
    y: 398.62,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.33,
    y: 389.21,
    width: 61.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.45,
    y: 395.11,
    width: 12.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.72,
    y: 395.11,
    width: 36.83,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 25.43,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.89,
    y: 390.89,
    width: 74.89,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.14,
    y: 85.44,
    width: 135.7,
    height: 189.78,
    transform: "translate(279.98 360.66) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.12,
    y: 85.44,
    width: 135.7,
    height: 189.78,
    transform: "translate(273.95 360.66) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.16,
    y: 117.89,
    width: 177.62,
    height: 124.87,
    transform: "translate(317.3 43.36) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.13,
    y: 179.19,
    width: 177.62,
    height: 2.28,
    transform: "translate(256.01 104.65) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.36,
    y: 151.05,
    width: 131.22,
    height: 8.16,
    transform: "translate(273.95 310.26) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,75.37H213.74a.84.84,0,0,1,.83.84h0a.83.83,0,0,1-.83.83H63.22a.83.83,0,0,1-.83-.83h0A.84.84,0,0,1,63.22,75.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.22,76.21A4.17,4.17,0,1,0,62.39,72,4.17,4.17,0,0,0,58.22,76.21Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,80.88h0a1.14,1.14,0,0,0,1.13-1.13V77.33a1.13,1.13,0,0,0-1.13-1.12h0a1.12,1.12,0,0,0-1.12,1.12v2.42A1.13,1.13,0,0,0,206.71,80.88Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79,80.88h0a1.14,1.14,0,0,0,1.13-1.13V77.33a1.13,1.13,0,0,0-1.13-1.12h0a1.12,1.12,0,0,0-1.12,1.12v2.42A1.13,1.13,0,0,0,75.79,80.88Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84,76.21h96.39a21.35,21.35,0,0,1,21.35,21.35V230.33a0,0,0,0,1,0,0H63.49a0,0,0,0,1,0,0V97.56A21.35,21.35,0,0,1,84.84,76.21Z",
    transform: "translate(266.07 306.54) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.15,76.21A4.17,4.17,0,1,0,193.31,72,4.16,4.16,0,0,0,189.15,76.21Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.29,
    y: 86.76,
    width: 116.08,
    height: 116.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.37,
    y: 86.76,
    width: 2,
    height: 116.39,
    transform: "translate(824.74 289.91) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.54,
    y: 94.11,
    width: 95.58,
    height: 101.69,
    rx: 47.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.92,
    y: 123.24,
    width: 40.83,
    height: 43.44,
    rx: 2.2,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.87,
    y: 319.12,
    width: 26.78,
    height: 59.39,
    transform: "translate(396.52 697.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.42,
    y: 378.51,
    width: 132.09,
    height: 3.76,
    transform: "translate(280.93 760.78) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.28,
    y: 319.12,
    width: 115.59,
    height: 59.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,346.41H79.81a.5.5,0,0,1-.5-.5V326.43a.5.5,0,0,1,.5-.5h94.53a.51.51,0,0,1,.5.5v19.48A.5.5,0,0,1,174.34,346.41Zm-94-1h93.53V326.93H80.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,371.7H79.81a.5.5,0,0,1-.5-.5V351.72a.5.5,0,0,1,.5-.5h94.53a.51.51,0,0,1,.5.5V371.2A.5.5,0,0,1,174.34,371.7Zm-94-1h93.53V352.22H80.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 334.84,
    width: 26.45,
    height: 2.67,
    rx: 1.18,
    transform: "translate(254.14 672.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 360.13,
    width: 26.45,
    height: 2.67,
    rx: 1.18,
    transform: "translate(254.14 722.92) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,309.13s-.32,10-12.66,10-12.67-10-12.67-10Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,309.13s-.33,10-12.67,10-12.66-10-12.66-10Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,309.13s-.32,10-12.67,10-12.66-10-12.66-10Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.68,
    y: 243.78,
    width: 20.21,
    height: 132.51,
    transform: "translate(867.57 620.08) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.89,
    y: 376.29,
    width: 166.67,
    height: 6.09,
    transform: "translate(710.45 758.68) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.56,
    y: 243.78,
    width: 157.12,
    height: 132.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.48,
    y: 291.67,
    width: 135.28,
    height: 31.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.48,
    y: 332.94,
    width: 135.28,
    height: 31.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.05,
    y: 289.51,
    width: 82.13,
    height: 4.32,
    rx: 2.05,
    transform: "translate(690.24 583.35) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.05,
    y: 330.77,
    width: 82.13,
    height: 4.32,
    rx: 2.05,
    transform: "translate(690.24 665.87) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.48,
    y: 250.41,
    width: 135.28,
    height: 31.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.05,
    y: 248.25,
    width: 82.13,
    height: 4.32,
    rx: 2.05,
    transform: "translate(690.24 500.83) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Programming--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.77,
    y: 101.5,
    width: 1,
    height: 5.28,
    transform: "translate(154.09 380.82) rotate(-83.53)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 93.66,
    width: 1,
    height: 17.13,
    transform: "translate(141.03 362.37) rotate(-83.53)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.32,
    y: 107.91,
    width: 190.87,
    height: 147.79,
    rx: 4.9,
    transform: "translate(22.35 -31.82) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,238l15.11-133.29a3.59,3.59,0,0,1,4-3.16l177.7,20.14a3.6,3.6,0,0,1,3.16,4L377.6,258.93a3.58,3.58,0,0,1-4,3.16l-177.7-20.15A3.58,3.58,0,0,1,192.78,238Z",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.67,
    y: 150.27,
    width: 75.36,
    height: 3.71,
    transform: "translate(19.21 -35.68) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.68,
    y: 157.27,
    width: 79.84,
    height: 3.71,
    transform: "translate(20.06 -36.68) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.06,
    y: 162.38,
    width: 66.15,
    height: 3.71,
    transform: "translate(20.58 -35.81) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.41,
    y: 167.87,
    width: 59.25,
    height: 3.71,
    transform: "translate(21.18 -35.31) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.67,
    y: 175.99,
    width: 48.96,
    height: 3.71,
    transform: "translate(22 -33.7) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.35,
    y: 194.71,
    width: 52.57,
    height: 3.71,
    transform: "translate(24.16 -34.42) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.04,
    y: 188.32,
    width: 43.56,
    height: 3.71,
    transform: "translate(23.42 -34.03) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 182.69,
    width: 47.97,
    height: 3.71,
    transform: "translate(22.8 -34.39) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.59,
    y: 220.84,
    width: 48.96,
    height: 3.71,
    transform: "translate(27.02 -32.84) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 239.56,
    width: 52.57,
    height: 3.71,
    transform: "translate(29.18 -33.56) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.96,
    y: 233.17,
    width: 43.56,
    height: 3.71,
    transform: "matrix(0.99, 0.11, -0.11, 0.99, 28.44, -33.17)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.61,
    y: 227.54,
    width: 47.97,
    height: 3.71,
    transform: "translate(27.82 -33.53) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 112.33,
    width: 39.76,
    height: 3.71,
    transform: "translate(14.36 -25.83) rotate(6.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.13,
    y: 130.84,
    width: 42.68,
    height: 3.71,
    transform: "translate(16.49 -26.36) rotate(6.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.82,
    y: 124.55,
    width: 35.37,
    height: 3.71,
    transform: "translate(15.76 -26.06) rotate(6.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 118.87,
    width: 38.95,
    height: 3.71,
    transform: "translate(15.13 -26.38) rotate(6.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.35,
    y: 212.35,
    width: 52.57,
    height: 3.71,
    transform: "translate(26.13 -34.08) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.04,
    y: 205.96,
    width: 43.56,
    height: 3.71,
    transform: "translate(25.39 -33.69) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.7,
    y: 200.33,
    width: 47.97,
    height: 3.71,
    transform: "translate(24.77 -34.05) rotate(6.47)",
    style: {
      fill: "#FAAE17"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "230.46 412.25 223.85 412.1 222.93 396.76 229.54 396.91 230.46 412.25",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.61,411.33l7.22.16a.58.58,0,0,1,.55.46l1.18,5.91a1,1,0,0,1-1,1.15c-2.6-.1-6.36-.33-9.63-.41-3.83-.08-4.52.59-9,.12-2.7-.28-3.17-3.09-2-3.22,5.26-.59,6.52-1,11-3.69A3.06,3.06,0,0,1,223.61,411.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.93 396.77 223.41 404.67 230.02 404.82 229.55 396.92 222.93 396.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,194.49c-2.2,4.31-4.52,8.48-7,12.64s-5,8.22-8,12.3c-.38.51-.8,1-1.2,1.55-.17.23-.46.56-.72.85s-.53.61-.82.88a16.86,16.86,0,0,1-3.79,2.86,20.81,20.81,0,0,1-8.44,2.58,29.4,29.4,0,0,1-8.05-.39,34.26,34.26,0,0,1-3.79-.9,30.23,30.23,0,0,1-3.71-1.33l1.6-5.05c1,.11,2.14.23,3.22.29s2.2.06,3.28,0a26.88,26.88,0,0,0,6.15-.78,13.54,13.54,0,0,0,4.88-2.21,9.14,9.14,0,0,0,1.7-1.64,4.1,4.1,0,0,0,.35-.47c.12-.16.22-.29.38-.54l.88-1.35c2.35-3.76,4.62-7.89,6.87-12l6.75-12.34Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,188c1,6-12.71,24.09-12.71,24.09L203.17,200a97.55,97.55,0,0,1,9.8-13.89C218.18,180.27,224.82,181.38,225.93,188Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.72,193.13c-4,1-10.74,5.25-14,13.51l4.53,5.46s8.13-10.69,11.41-18.37A1.76,1.76,0,0,0,222.72,193.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.84,182.33S208.3,195.77,209,234.56L244.61,241c1.23-5.42,1.67-27.47,11.6-52.27a94.52,94.52,0,0,0-11.65-3.66,131.4,131.4,0,0,0-15.14-2.74A68,68,0,0,0,218.84,182.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,203.87c-1.52,2.15-2.44,8-.39,12,.48-2.48,1.05-5.08,1.73-7.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.42,182.33s-4.27,8.39.71,12.75c8.71-.74,14.43-10,14.43-10Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.28 217.13 164.39 222.1 168.69 225.21 170.63 218.39 164.28 217.13",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.29,221l-7.66-2.61-1.94,6.82s4.46,1.94,8-.66Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14,167.75c-1.84,4.7-4.4,13.45-1.58,17.32,0,0-3.88,4.53-12.59,5.27-5-4.36-2.55-8-2.55-8,5.67-.32,6.25-4.37,6-8.33Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,170.3l-6.35,3.7a17,17,0,0,1,0,2.77c2.82,1.45,5.12-.07,6.35-3.12A7.53,7.53,0,0,0,241.77,170.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,162.35c.41,3,9.66-1.89,11.22-2.92s-.23-4.6-3.74-7.48S231.13,155.34,232.08,162.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.06,163.73c-2.83,6.09-4.17,9.8-8.58,11.76-6.62,3-13.21-2.91-12.26-9.72.85-6.13,5.33-15.06,12.41-15.16A9.16,9.16,0,0,1,251.06,163.73Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.56,169.43c-3,.45-.88-9.8-.33-11.58s5.31-3.41,8,.25C259.46,162.57,255.56,168.39,248.56,169.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.66,148.58c-2.69-.54-1.92-3.39.06-3.24-1.59-1.93-11-3.69-11.51,2.55s11.62,9.7,14.9,10.14L256,159.4C262.59,156.11,255.28,150.11,247.66,148.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,171.1a6.38,6.38,0,0,1-4.57,1.71c-2.23-.1-2.66-2.26-1.46-4,1.07-1.58,3.54-3.43,5.51-2.48A2.87,2.87,0,0,1,251.39,171.1Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.34 399.85 203.85 401.13 200.67 386.15 207.16 384.87 210.34 399.85",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.44,400.43l7.09-1.4a.58.58,0,0,1,.64.34l2.41,5.51a1,1,0,0,1-.7,1.34c-2.57.46-6.29,1-9.5,1.67-3.76.74-5,.82-9.37,1.69-2.67.52-3.94-2-2.87-2.49,4.86-2.11,7-2.28,10.84-5.85A3,3,0,0,1,203.44,400.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.67 386.15 202.31 393.87 208.8 392.59 207.16 384.87 200.67 386.15",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,402a2,2,0,0,1-1.34.12.93.93,0,0,1-.6-.68.5.5,0,0,1,.1-.52c.56-.61,3.08-.11,3.36-.05a.17.17,0,0,1,.13.13.16.16,0,0,1-.07.16A8,8,0,0,1,201,402Zm-1.42-1a.5.5,0,0,0-.18.11s-.07.09,0,.21a.63.63,0,0,0,.4.47,3.25,3.25,0,0,0,2.3-.71A6.49,6.49,0,0,0,199.54,401Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.51,401.13h-.08c-.79-.12-2.57-1-2.7-1.8a.52.52,0,0,1,.34-.57.84.84,0,0,1,.71,0c1,.33,1.78,2.11,1.82,2.18a.15.15,0,0,1,0,.16A.13.13,0,0,1,202.51,401.13ZM200.28,399l-.07,0c-.18.1-.17.2-.16.24.07.44,1.27,1.2,2.1,1.46-.27-.51-.86-1.51-1.47-1.72A.61.61,0,0,0,200.28,399Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,234.56s-15.81,60.18-20.38,80.31c-4.74,20.95,11.23,77.56,11.23,77.56l10.55-2.08s-4.43-57.72-2.92-66.88c6.05-22.18,24.93-84.67,24.93-84.67Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,284.44a133.93,133.93,0,0,0,.4,25.16c4.52-15.73,10.8-36.83,15.32-51.9C222.16,259.67,212.69,265.92,211,284.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,236.79s-8.28,61.32-7.57,81.14c.77,21.69,5.9,84.77,5.9,84.77L232,403s-.19-59.64,1-80.78c1.24-22.94,11.3-81.25,11.3-81.25Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.83 403.25 219.48 402.96 218.43 397.9 233.21 397.81 232.83 403.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.48 390.21 199.38 392.79 197.26 388.07 211.78 385.48 212.48 390.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,161.91c-.2.51-.63.82-1,.69s-.44-.65-.24-1.16.63-.81,1-.68S241.49,161.41,241.3,161.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,159.67c-.2.5-.63.81-1,.68s-.44-.65-.24-1.15.63-.82,1-.69S235.75,159.16,235.55,159.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.89,160.48a19.51,19.51,0,0,1-4.13,3.4,3.18,3.18,0,0,0,2.25,1.41Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,167.75a.16.16,0,1,1,.13-.29,4.35,4.35,0,0,0,3.91-.13.16.16,0,1,1,.17.27A4.55,4.55,0,0,1,234.92,167.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.48,160.76a.35.35,0,0,1-.16-.23A2.57,2.57,0,0,0,243,158.6a.32.32,0,0,1-.16-.42.33.33,0,0,1,.43-.16,3.18,3.18,0,0,1,1.65,2.41.32.32,0,0,1-.27.37A.34.34,0,0,1,244.48,160.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,156.24a.24.24,0,0,1-.1-.1.31.31,0,0,1,.1-.44,3.2,3.2,0,0,1,2.91-.29.33.33,0,0,1,.16.43.32.32,0,0,1-.43.15h0a2.54,2.54,0,0,0-2.3.25A.32.32,0,0,1,234.1,156.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.15,186.57l-1.66-.45a.33.33,0,0,0-.4.2c-9.22,24.28-11.41,51.43-11.41,51.43l1.85.33A243.61,243.61,0,0,1,251.37,187,.32.32,0,0,0,251.15,186.57Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.99
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.8,238.13a.6.6,0,0,0-.49-.7l-1.28-.24a.61.61,0,0,0-.36,1.15l-.28,1.59a.79.79,0,1,0,1.56.28l.29-1.59A.61.61,0,0,0,239.8,238.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,181.81h-1.72a.33.33,0,0,0-.31.23c-8.08,24.5-8.88,51-8.88,51l1.85.34c2.18-27.86,8.36-48,9.38-51.2A.33.33,0,0,0,222.89,181.81Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,233.49a.64.64,0,0,0-.52-.71l-1.28-.24a.58.58,0,0,0-.68.5.65.65,0,0,0,.38.66l-.21,1.6a.84.84,0,0,0,.68.93.75.75,0,0,0,.89-.65l.21-1.6A.56.56,0,0,0,214.1,233.49Z",
    style: {
      fill: "#263238",
      opacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,412.28a2,2,0,0,1-1.33-.16,1,1,0,0,1-.45-.8.5.5,0,0,1,.21-.48c.69-.48,3,.55,3.3.67a.18.18,0,0,1,.1.15.18.18,0,0,1-.11.14A7.49,7.49,0,0,1,220.86,412.28ZM219.68,411a.4.4,0,0,0-.2.07.19.19,0,0,0-.08.2.68.68,0,0,0,.3.55,3.21,3.21,0,0,0,2.39-.21A6.53,6.53,0,0,0,219.68,411Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55,411.81h-.08c-.75-.29-2.29-1.57-2.25-2.34a.54.54,0,0,1,.45-.49.9.9,0,0,1,.71.12c.86.53,1.29,2.44,1.3,2.52a.16.16,0,0,1-.05.16A.11.11,0,0,1,222.55,411.81Zm-1.72-2.53h-.08c-.2.06-.2.16-.21.2,0,.45,1,1.44,1.75,1.87a3.94,3.94,0,0,0-1.08-2A.54.54,0,0,0,220.83,409.28Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.46 257.8 231.05 261.75 235.24 258.66 229.88 252.13 225.46 257.8",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.79,250.94l-7.91,1.19,5.36,6.53s5.49-1.34,5.19-5.74Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,199.08c.3,5.22.46,10.42.49,15.66,0,2.61,0,5.23,0,7.87,0,1.31-.05,2.63-.12,4l-.1,2-.05,1c0,.47-.1,1-.17,1.5a16.86,16.86,0,0,1-1.7,5A31.48,31.48,0,0,1,257,240a50.64,50.64,0,0,1-5.61,6.32,80.73,80.73,0,0,1-12.77,9.95l-3.24-4.2c1.74-1.76,3.56-3.59,5.24-5.47s3.35-3.75,4.88-5.67a50.74,50.74,0,0,0,4.09-5.84,22.27,22.27,0,0,0,1.41-2.87,8.75,8.75,0,0,0,.63-2.42,3.37,3.37,0,0,1,0-.45l0-.92-.05-1.88-.16-3.81L251,215c-.26-5.14-.47-10.32-.61-15.47Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21,188.73c8.55,3.18,8.48,26.05,8.48,26.05l-14.47,2.66s-3.5-10.39-1.77-18.57C250.1,191.06,249.71,186.3,256.21,188.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--JS--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.84,218.15l-38.76-14.52-6.81-40.82,32-26.31L171,151l6.81,40.83Zm-37.13-15.86,36.78,13.77,30.31-25-6.46-38.73-36.78-13.77-30.31,25Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.39,
    cy: 137.55,
    r: 6.21,
    transform: "translate(-56.48 165.36) rotate(-54.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.66,
    cy: 217.1,
    r: 6.21,
    transform: "translate(-115.67 209.48) rotate(-54.47)",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,156.74a6.21,6.21,0,1,1,8.66-1.44A6.21,6.21,0,0,1,166.55,156.74Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.64,168.17a6.21,6.21,0,1,1,8.66-1.45A6.22,6.22,0,0,1,97.64,168.17Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,196.59a6.21,6.21,0,1,1,8.67-1.45A6.21,6.21,0,0,1,173.19,196.59Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.29,208a6.21,6.21,0,1,1,8.66-1.44A6.2,6.2,0,0,1,104.29,208Z",
    style: {
      fill: "#FAAE17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.94,167l7.83-1.31,2.29,13.73a21.92,21.92,0,0,1,.33,6.71,7.66,7.66,0,0,1-2.45,4.34,10.45,10.45,0,0,1-5.68,2.56,13.94,13.94,0,0,1-6.1,0,7.62,7.62,0,0,1-3.76-2.49,11.53,11.53,0,0,1-2.17-4.69l7.29-2.27a8.85,8.85,0,0,0,.71,2.44,2.77,2.77,0,0,0,1.15,1.15,2.17,2.17,0,0,0,1.33.12,2.13,2.13,0,0,0,1.76-1.3,6.61,6.61,0,0,0,.07-3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,181.94l7.36-1.7a5.7,5.7,0,0,0,1.44,2.59,4.19,4.19,0,0,0,3.71,1,3.83,3.83,0,0,0,2.44-1.21,2.4,2.4,0,0,0,.61-2,2.36,2.36,0,0,0-1.16-1.62,10.19,10.19,0,0,0-4.25-.79q-5.33-.3-7.84-1.85a6.28,6.28,0,0,1-3-4.51,6.78,6.78,0,0,1,.52-3.87,7.58,7.58,0,0,1,2.94-3.29,16,16,0,0,1,6-2q4.85-.81,7.69.57a7.85,7.85,0,0,1,4,5.22l-7.29,1.66a3.49,3.49,0,0,0-4.37-2.62,3.19,3.19,0,0,0-2,.92,1.8,1.8,0,0,0-.46,1.52,1.44,1.44,0,0,0,.75,1,6.58,6.58,0,0,0,2.78.49,33.38,33.38,0,0,1,7.71,1,7.88,7.88,0,0,1,3.69,2.26,7.23,7.23,0,0,1,1.63,3.58,8.08,8.08,0,0,1-.6,4.7,8.39,8.39,0,0,1-3.24,3.74,15.33,15.33,0,0,1-5.91,2.08q-6.45,1.08-9.34-1A10,10,0,0,1,140.43,181.94Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScriptframeworksRafiki);
export default __webpack_public_path__ + "static/media/JavaScript frameworks-rafiki.93a10f54e08748ad2c734066d8691f56.svg";
export { ForwardRef as ReactComponent };